"use client";

import * as React from "react";

export interface PageRootProps {
  children: React.ReactNode;
}

/** Envoltorio app con spectrum band — solo para páginas con PageHeader. */
export function PageRoot({ children }: PageRootProps) {
  React.useEffect(() => {
    const appMainScroll = document.getElementById("app-main-scroll");
    if (!appMainScroll) return;

    appMainScroll.style.setProperty("--site-spectrum-duration", "2000ms");
    appMainScroll.style.setProperty(
      "--site-spectrum-easing",
      "cubic-bezier(0.16, 1, 0.3, 1)",
    );
    appMainScroll.style.setProperty("--site-spectrum-iterations", "1");
    appMainScroll.style.setProperty("--site-spectrum-fill", "forwards");
    appMainScroll.style.setProperty("--site-spectrum-start-x", "0%");
    appMainScroll.style.setProperty("--site-spectrum-end-x", "72%");

    return () => {
      appMainScroll.style.removeProperty("--site-spectrum-duration");
      appMainScroll.style.removeProperty("--site-spectrum-easing");
      appMainScroll.style.removeProperty("--site-spectrum-iterations");
      appMainScroll.style.removeProperty("--site-spectrum-fill");
      appMainScroll.style.removeProperty("--site-spectrum-start-x");
      appMainScroll.style.removeProperty("--site-spectrum-end-x");
    };
  }, []);

  return <div>{children}</div>;
}
